import Moment from 'moment';

const USERS_TABLE = {
  columns: [
    {
      label: 'users.full_name_header',
      field: 'client.firstName,client.lastName',
      getValue: (raw) => {
        if (raw.firstName && raw.lastName) {
          return raw.firstName + ' ' + raw.lastName
        } else {
          return '';
        }
      },
      ordering: true
    },
    {
      label: 'users.email_header',
      field: 'client.email',
      getValue: (raw) => {
        return raw.email
      },
      ordering: true
    },
    {
      label: 'users.phone_header',
      field: 'client.phone',
      getValue: (raw) => {
        return raw.phone ? raw.phone.fullNumber : ''
      },
      ordering: true
    },
    {
      label: 'users.status_header',
      field: 'status',
      ordering: true,
      translate: true,
      getValue(raw) {
        return 'user_status.' + raw.status;
      }
    },
    {
      label: 'users.accept_waiver_header',
      field: 'acceptWaiver',
      getValue: (raw) => {
        return raw.acceptWaiver ? raw.acceptWaiver : '-'
      },
      ordering: true
    },
    {
      label: 'users.activated_at_header',
      field: 'activatedAt',
      getValue: (raw) => {
        return raw.activatedAt ? Moment(raw.activatedAt).format('DD MMM YYYY') : '-'
      },
      ordering: true
    },
    {
      label: 'users.actions_header',
      field: 'actions',
      ordering: false,
      getStyle(raw) {
        return {
          display: 'block',
          textAlign: 'center'
        };
      },
      preventClick: true
    }
  ]
}

export default USERS_TABLE;
